import React, { useEffect } from "react";

export const InImageAd = ({ blockId }) => {
    if (!blockId) {
        return null;
    }

    useEffect(() => {
        const render = (imageId) => {
            window.yaContextCb.push(() => {
                Ya.Context.AdvManager.render({
                    renderTo: imageId,
                    blockId: blockId,
                    type: "inImage",
                });
            });
        };

        const renderInImage = (images) => {
            if (!images.length) {
                return;
            }
            const image = images.shift();
            image.id = `yandex_rtb_${blockId}-${Math.random().toString(16).slice(2)}`;
            if (image.tagName === "IMG" && !image.complete) {
                image.addEventListener(
                    "load",
                    () => {
                        render(image.id);
                    },
                    { once: true }
                );
            } else {
                render(image.id);
            }
            renderInImage(images);
        };

        renderInImage(Array.from(document.querySelectorAll("img")));
    }, []);

    return null;
};
